import { render } from "./RejectModerationModal.vue?vue&type=template&id=572b09a0&ts=true"
import script from "./RejectModerationModal.vue?vue&type=script&lang=ts"
export * from "./RejectModerationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__